// extracted by css-extract-rspack-plugin
export default {"cls1":"Badge-cls1_slG","cls2":"Badge-cls2_JbI Badge-cls1_slG"};